import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import TermsSection from "../../components/TermsSection/TermsSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
const TermsPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Terms &amp; Conditions | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Read the terms and conditions for participating in the Cash Flow Summit 2026, including policies, guidelines, and legal information."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit terms, Cash Flow Summit conditions, event terms and conditions"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="noindex, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Terms & Conditions"} pagesub={"Terms & Conditions"} />
      <TermsSection />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default TermsPage;
